import { computed, inject, Injectable, signal } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { distinctUntilChanged, fromEvent, map, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private readonly _platform = inject(Platform);

  readonly isNative = signal(this._platform.is('capacitor'));

  readonly isMobile = computed(() => this.layout() === 'mobile');
  readonly isTablet = computed(() => this.layout() === 'tablet');
  readonly isDesktop = computed(() => this.layout() === 'desktop');

  readonly layout = signal<'mobile' | 'tablet' | 'desktop'>('mobile', { equal: Object.is });

  initBreakpoints() {
    const calcLayout = (): 'mobile' | 'tablet' | 'desktop' => {
      const width = window.screen.width;

      // En apps móviles (Capacitor) Ionic siempre actúa como mobile
      if (this.isNative()) return 'mobile';

      // En navegador, sí podemos usar el ancho real
      if (width < 768) return 'mobile';
      if (width < 992) return 'tablet';
      return 'desktop';
    };

    const layout$ = fromEvent(window, 'resize').pipe(
      startWith(0),
      map(() => calcLayout()),
      distinctUntilChanged(),
    );

    layout$.subscribe((l) => this.layout.set(l));
  }
}
